import styled from 'styled-components'

export const ProfessionalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 20px;
`

export const ProfessionalTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  flex: 1;   
`

export const ProfessionalViewAll = styled.a`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.blue100};
  cursor: pointer;
  white-space: nowrap;
  margin-top: 7px;
`

export const ProfessionalCourseList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const ProfessionalCourseItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

export const ProfessionalIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`

export const ProfessionalIconImage = styled.img`
  height: 20px;
  object-fit: contain;
`

export const ProfessionalCourseContent = styled.div`
  display: flex;
  flex-direction: column;
  a {
    font-weight: 600;
    font-size: 1.04rem;
    color: ${({ theme }) => theme.palette.blue100};
    text-decoration: none;
    line-height: 1.3;
  }
`

export const ProfessionalCourseTitle = styled.a`
  font-size: 18px;
  font-weight: 600;
  color: #0070d2;
  cursor: pointer;
  text-decoration: none;
  line-height: 1.2;
  margin-bottom: 4px;
  &:hover {
    text-decoration: underline;
  }
`

export const ProfessionalCourseDesc = styled.p`
  font-size: 15px;
  line-height: 1.2;
  color: #0c0b0b;
  margin: 4px 0 25px 0;
`